import { render, staticRenderFns } from "./DocumentsFinder.vue?vue&type=template&id=395c091e&scoped=true&"
import script from "./DocumentsFinder.vue?vue&type=script&lang=ts&"
export * from "./DocumentsFinder.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsFinder.vue?vue&type=style&index=0&id=395c091e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395c091e",
  null
  
)

export default component.exports